import FeatureReferenceSourceType from './FeatureReferenceSourceType.js';
/**
 * @memberof feature-references
 * @classdesc
 * Used to specify a related set of features that come from a single source
 * they can be either System or Customer features, and be either a
 * feature class or user layer.
 *
 * @property {feature-references.FeatureReferenceSourceType} type
 * @property {number} sourceId - ID of a user layer or feature class
 */
class LayerReference {
    /**
     * @param {object} props
     * @param {feature-references.FeatureReferenceSourceType} props.type
     * @param {number} props.sourceId
     */
    constructor(props) {
        this.type = props.type;
        this.sourceId = props.sourceId;
    }
    /**
     * @param {feature-references.LayerReference}
     * @return {boolean}
     */
    isEqual(ref) {
        return ref.key === this.key;
    }
    /**
     * @type {string}
     */
    get key() {
        return `${this.type}:${this.sourceId}`;
    }
}
/**
 * @type {feature-references.FeatureReferenceSourceType}
 */
LayerReference.SourceType = FeatureReferenceSourceType;
export default LayerReference;
